import { c as _c } from "react/compiler-runtime";
import { StarIcon } from '@winelidays/wld-tsx-2/images';
const StarRating = t0 => {
    const $ = _c(11);
    const { rating: t1, className } = t0;
    const rating = t1 === undefined ? 0 : t1;
    const trueRating = rating / 10;
    let t2;
    if ($[0] !== trueRating) {
        t2 = Array.from({
            length: 5
        }, (v, i) => <StarIcon key={i} className={`w-3 h-3 ${trueRating >= i + 1 ? "text-rating" : "text-gray-200"}`}/>);
        $[0] = trueRating;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const totalStarRating = t2;
    const computedClassName = `inline-flex w-20 justify-between items-center ${className}`;
    const seoRating = `${trueRating}`;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <meta itemProp="worstRating" content="0"/>;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    let t4;
    if ($[3] !== seoRating) {
        t4 = <meta itemProp="ratingValue" content={seoRating}/>;
        $[3] = seoRating;
        $[4] = t4;
    }
    else {
        t4 = $[4];
    }
    let t5;
    if ($[5] !== computedClassName || $[6] !== totalStarRating) {
        t5 = <span className={computedClassName}>{totalStarRating}</span>;
        $[5] = computedClassName;
        $[6] = totalStarRating;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = <>{t3}{t4}{t5}</>;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    }
    else {
        t6 = $[10];
    }
    return t6;
};
export default StarRating;
